import React, { useEffect, useState, useRef } from "react";
import $, { data } from "jquery";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import CountUp from "react-countup";
import AddContract from "../../components/Modals/Contract/AddContract";
import EditContract from "../../components/Modals/Contract/EditContract";
import Contracts from "../../components/Modals/Contract/Contracts";
import UploadContract from "../../components/Modals/Contract/UploadContract";
import SetContractOption from "../../components/Modals/Contract/SetContractOption";
import DPAFiles from "../../components/Modals/Contract/DPAFiles";
import useSmartBack from "../../hooks/useSmartBack";

function Contract() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const { setGlobalLoading, token } = useOutletContext();
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const navigate = useNavigate();

  const [options, setoptions] = useState([]);
  const [total_contracts, settotal_contracts] = useState(null);
  const [active_contracts, setactive_contracts] = useState(null);
  const [expired_contracts, setexpired_contracts] = useState(null);
  const [expired_soon_contracts, setexpiredsoon_contracts] = useState(null);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [Model, setModel] = useState(false);
  const [EditModel, setEditModel] = useState(false);
  const [UploadModel, setUploadModel] = useState(false);
  const [uploadContractData, setUploadContractData] = useState([]);
  const [contractid, setcontractid] = useState(null);
  const [contractShowModel, setContractShowModel] = useState(false);
  const [newContractId, setNewContractId] = useState(false);
  const [setContractOptionModel, setSetContractOptionModel] = useState(false);
  const [dpaFilesModal, setDpaFilesModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);

  const fetchOptions = async () => {
    setGlobalLoading(true); //  Show loader before API call
    setNewContractId(false);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/contracts/get_contract_list/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //    console.log(response.data);
      setoptions(response.data.total_contracts || []);
      settotal_contracts(response.data.total_contracts);
      setactive_contracts(response.data.active_contracts);
      setexpired_contracts(response.data.expired_contracts);
      setexpiredsoon_contracts(response.data.expired_soon_contracts);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (options.length > 0) return;
    fetchOptions();
  }, []);

  const filterform = async (data) => {
    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/contracts/get_contract_filtered_list/`,
        {
          formData: data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setoptions(response.data.contract || []);
      console.log(response.data.contract);
      //  setOptionsLoaded(true);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
      //  window.location.reload();
      //  setOptionsLoaded(true);
    } finally {
      setGlobalLoading(false);
    }
  };
  const exportContractDoc = async ({ apiUrl, id, token }) => {
    try {
      const response = await axios.get(
        `${apiUrl}/contracts/export-contract/${id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `contract_${id}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      if (err.response && err.response.data) {
        try {
          // Read error blob as text then parse JSON message
          const text = await err.response.data.text();
          const json = JSON.parse(text);

          // Show the backend error message
          // alert(json.message || "An error occurred");
          // Navigate after alert OK click
          // After alert is closed (user clicked OK), redirect to the file URL if filename exists
          if (json.savename) {
  fetch(`${BASE_URL_BACK}contract_files/${json.savename}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(res => {
      if (!res.ok) throw new Error("Unauthorized");
      return res.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    })
    .catch(err => console.error(err));
}
 else {
            // fallback navigation if no filename
            navigate("/contract/list");
          }
        } catch {
          alert("An unexpected error occurred");
        }
      } else {
        alert("An unexpected error occurred");
      }
      console.error("Error exporting contract:", err);
    }
  };

  const columns = [
    {
      accessorKey: "id",
      header: "",
      size: 70,
      Cell: ({ row }) => (
        <>
          <a
            href="javascript:void(0)"
            onClick={() => OpenEditContractModal(row.original.id)}
            title="Edit Contract"
          >
            <i className="fa-solid fa-pen"></i>
          </a>
          <a
            onClick={() =>
              exportContractDoc({
                apiUrl: API_BASE_URL,
                id: row.original.id,
                token,
              })
            }
            className="ms-2"
            title="Export Contract"
          >
            <i className="fa-solid fa-file-arrow-down"></i>
          </a>
          {row.original.has_dpa_files == 1 && (
              <a
                  onClick={() => {
                      setSelectedContract(row.original);
                      setDpaFilesModal(true);
                  }}
                  className="ms-2"
                  title="View DPA Files"
              >
                  <i className="fa-solid fa-folder-open"></i>
              </a>
          )}
        </>
      ),
    },
    {
      accessorKey: "company",
      header: "Company Name",
      size: 120,
      Cell: ({ row }) => (
        <a
          href="javascript:void(0)"
          onClick={(e) => handleOpenModal(e, row.original.id)}
          title="view contract"
        >
          <b>{row.original.company}</b>
        </a>
      ),
    },
    {
      accessorKey: "agn",
      header: "AGN No.",
      size: 100,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 100,
    },
    {
      accessorKey: "contractSigned",
      header: "Signed",
      size: 100,
      Cell: (info) => (info.cell.getValue() === "1" ? "Yes" : "No"),
    },
    {
      accessorKey: "entity",
      header: "Entity",
      size: 70,
    },
    {
      accessorKey: "contract_type",
      header: "Contract Type",
      size: 70,
    },
    {
      accessorKey: "contractstart",
      header: "Contract Start",
      size: 70,
    },
    {
      accessorKey: "contractend",
      header: "Contract End",
      size: 70,
    },
    {
      accessorKey: "fee",
      header: "Fee %",
      size: 50,
    },
    {
      accessorKey: "expensePercent",
      header: "Expense",
      size: 50,
    },
    {
      accessorKey: "splits",
      header: "Splits",
      size: 50,
    },
    {
      accessorKey: "uploaded_by",
      header: "Uploded By",
      size: 100,
    },
    {
      accessorKey: "comments",
      header: "Comments",
      size: 100,
    },
  ];

  const handleReset = () => {
    reset();
    window.location.reload();
  };

  const showTotalContracts = async () => {
    try {
      setGlobalLoading(true);
      setoptions(total_contracts);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };
  const showActiveContracts = async () => {
    try {
      setGlobalLoading(true);
      setoptions(active_contracts);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };
  const showExpiredContracts = async () => {
    try {
      setGlobalLoading(true);
      setoptions(expired_contracts);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };
  const showTosoonContracts = async () => {
    try {
      setGlobalLoading(true);
      setoptions(expired_soon_contracts);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const OpenAddContractModal = () => {
    setModel(true);
  };

  const OpenEditContractModal = (id) => {
    setGlobalLoading(true);
    setSelectedContractId(id);
    setEditModel(true);
  };

  const handleOpenModal = (e, id) => {
    e.preventDefault();
    setSelectedContractId(id);
    setContractShowModel(true);
  };

  const removeUploadedContract = async (id) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/contracts/delete_contract_file/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        navigate("/contract/list");
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleBack = useSmartBack("/client/list");
  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Contract</h2>
            
          </div>
          <div className="d-flex list-group-horizontal border-0">
            {/* <button
              onClick={(e) => OpenAddContractModal()}
              type="button"
              className="btn btn-primary btn-sm"
            >
              <i className="fa-solid fa-file-contract fs-16"></i> Create New
              Contract
            </button> */}
            {dpaFilesModal && (
                <DPAFiles
                    contract={selectedContract}
                    onClose={() => setDpaFilesModal(false)}
                />
            )}
             
            {Model && (
              <AddContract
                onClose={(data) => {
                  setModel(false);
                  if (data != undefined) {
                    setSelectedContractId(data.contract_id);
                    setContractShowModel(true);
                    setNewContractId(true);
                  } else {
                    if (contractid != null) {
                      removeUploadedContract(contractid);
                      setUploadContractData([]);
                      setcontractid(null);
                    }
                  }
                }}
                updata={uploadContractData}
                contract_id={contractid}
              />
            )}
            {/* <button
              title="Upload Contract"
              type="button"
              className="btn btn-primary ms-2"
              onClick={() => setUploadModel(true)}
            >
              <i className="fa-solid fa-file-arrow-up fs-16"></i>
            </button> */}

            {UploadModel && (
              <UploadContract
                onClose={(data) => {
                  setUploadModel(false);
                  setcontractid(data.contract_id);
                  setUploadContractData(data.response);
                  data.response != undefined && setModel(true);
                }}
              />
            )}
            
            <button
              className="btn btn-primary ms-2"
              title="Add Contract"
              type="button"
              onClick={() => setSetContractOptionModel(true)}
            >
              <i className="fa-solid fa-plus me-1"></i>
              Add Contract
            </button>
            <button
              className="btn btn-outline-secondary ms-2 d-inline-flex align-items-center"
              onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-1"></i> Back
            </button>

            {setContractOptionModel && (
              <SetContractOption
                onClose={(data) => {
                  setSetContractOptionModel(false);
                  console.log(data);
                  data.model == "upload" && setUploadModel(true);
                  data.model == "manually" && setModel(true);
                }}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-3 col-md-6 d-flex"
            style={{ cursor: "pointer" }}
            onClick={() => showTotalContracts()}
          >
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center">
                        <i className="ti ti-news text-pink fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Total Contracts
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={total_contracts ? total_contracts.length : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-3 col-md-6 d-flex"
            style={{ cursor: "pointer" }}
            onClick={() => showActiveContracts()}
          >
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center">
                        <i className="ti ti-checkbox fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Active Contracts
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={active_contracts ? active_contracts.length : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-3 col-md-6 d-flex"
            style={{ cursor: "pointer" }}
            onClick={() => showExpiredContracts()}
          >
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center">
                        <i className="ti ti-note-off fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Expired Contracts
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={
                            expired_contracts ? expired_contracts.length : "0"
                          }
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-3 col-md-6 d-flex"
            style={{ cursor: "pointer" }}
            onClick={() => showTosoonContracts()}
          >
            <div className="card flex-fill">
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center">
                        <i className="ti ti-squares-selected fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        To Expire Soon
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={
                            expired_soon_contracts
                              ? expired_soon_contracts.length
                              : "0"
                          }
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {contractShowModel && (
            <Contracts
              onClose={() => {
                setContractShowModel(false);
                console.log(newContractId);
                newContractId && fetchOptions();
              }}
              contractid={selectedContractId}
            />
          )}
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div
            className="accordion accordion-secondary"
            id="accordionSecondaryExample"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSecondaryOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSecondaryOne"
                  aria-expanded="false"
                  aria-controls="collapseSecondaryOne"
                >
                  Use filters to find specific set of contracts:
                </button>
              </h2>
              <div
                id="collapseSecondaryOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingSecondaryOne"
                data-bs-parent="#accordionSecondaryExample"
              >
                <div className="accordion-body">
                  <form onSubmit={handleSubmit(filterform)}>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Contract Type:
                            <span className="text-danger">
                              *{" "}
                              {errors.client_type && errors.client_type.message}
                            </span>
                          </label>
                          <select
                            {...register("client_type")}
                            className="form-select"
                          >
                            <option key={0} value={""}>
                              Select Contract Type
                            </option>
                            <option key={1} value={2}>
                              Contingent
                            </option>
                            <option key={2} value={3}>
                              Retained
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Status:</label>
                          <select
                            {...register("client_status")}
                            className="form-select"
                          >
                            <option key={0} value={""}>
                              Select Option
                            </option>
                            <option key={4} value={"4"}>
                              New
                            </option>
                            <option key={5} value={"5"}>
                              Expired
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <button type="submit" className="btn btn-primary">
                          Search with filter(s)
                        </button>
                      </div>
                      <div
                        className="col-md-3 md-offset-6"
                        style={{ marginLeft: "-65px" }}
                      >
                        <button
                          className="btn btn-secondary"
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={options}
                initialState={{
                  pagination: { pageSize: 200 },
                }}
                muiTableBodyRowProps={{
                  sx: {
                    height: "20px", // compact row height
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {EditModel && (
        <EditContract
          id={selectedContractId}
          onClose={() => {
            setEditModel(false);
            fetchOptions();
          }}
        />
      )}
    </>
  );
}

export default Contract;
